import { TemplatePage } from './types';

const seasonPage: TemplatePage = {
  header: {
    color: '#E9DCCB',
    icon: 'images/video-templates/holiday.jpg',
    title: 'Holiday Season Video Templates',
    title_meta: 'Easily Customizable Holiday Season Video Templates',
    description_meta:
      ' Find video templates for any of your holiday season needs: promo campaigns, sales and specials, ' +
      'greetings and more.',
    description:
      'Beat the holiday postage service rush with digital video postcards. Deliver your ' +
      'greetings, offers, discount sales, promotions etc. instantaneously by emailing or ' +
      'posting videos on social media!'
  },
  footer: {
    category: 'Holiday Season',
    description:
      'Wave.video platform got video templates for all your needs this Holiday season. We have fun holiday ' +
      'video templates, lyric video templates, big discounts video templates and warm wishes video templates, ' +
      'plenty to choose from for your and your clients. <br>Pick from various styles, easily customize for ' +
      'your brand with logos, visual overlays, pictures in pictures, custom fonts and colors, automatic captions, ' +
      'and more. Take advantage of the unique ability to create, customize, publish, send in emails, embed on your ' +
      'website all on one platform! Make your video beautiful in minutes! You and your customers deserve it!'
  },
  content: [
    {
      type: 'templates',
      title: 'holiday season',
      search: { category: '/Holidays & Occasions/Holiday Season' }
    },
    {
      type: 'stocks',
      title: 'holiday season',
      search: { name: 'holiday season' }
    },
    { type: 'calendar' }
  ]
};

export default seasonPage;
